import { createFileRoute } from "@tanstack/react-router";
import FeynmanTechniqueGuide from "@/pages/resources/FeynmanTechniqueGuide";

export const Route = createFileRoute("/learn/feynman-technique")({
  head: () => ({
    meta: [
        {
            "title": "The Feynman Technique: Learn Anything by Teaching It | System Atlas"
        },
        {
            "name": "description",
            "content": "Master the Feynman Technique to learn complex topics faster. A step-by-step guide to the learning method used by one of history's greatest physicists."
        },
        {
            "property": "og:title",
            "content": "The Feynman Technique: Learn Anything by Teaching It | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Master the Feynman Technique to learn complex topics faster. A step-by-step guide to the learning method used by one of history's greatest physicists."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/feynman-technique"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "The Feynman Technique: Learn Anything by Teaching It | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Master the Feynman Technique to learn complex topics faster. A step-by-step guide to the learning method used by one of history's greatest physicists."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/feynman-technique"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/feynman-technique"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/feynman-technique"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/feynman-technique"
        }
    ],
  }),
  component: FeynmanTechniqueGuide,
});
